import { useOptionalNotificationsSessionContext } from '@app/modules/notifications/session/useNotificationsSessionContext';
import { SidenavNotificationsButtonKnock } from './SidenavNotificationsButtonKnock';
import { SidenavNotificationsButtonShell } from './SidenavNotificationsButtonShell';

export type SidenavNotificationsButtonProps = {
  /** Unread count when Knock is unavailable (defaults to 0). */
  count?: number;
};

/**
 * Notification bell for the identity row. Hidden when the backend returns
 * provider `noop`. Uses Knock unread count when the feed is ready.
 */
export function SidenavNotificationsButton({ count = 0 }: SidenavNotificationsButtonProps) {
  const session = useOptionalNotificationsSessionContext();

  if (session?.provider === 'noop') {
    return null;
  }

  if (session?.isKnockReady) {
    return <SidenavNotificationsButtonKnock />;
  }

  return <SidenavNotificationsButtonShell count={count} />;
}
